import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {DatabaseService} from "../../providers/database.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  public newsletter: FormGroup;
  private success = false;
  private error = false;
  constructor(public formBuilder: FormBuilder,
              public db: DatabaseService) {
    this.getNewsForm();
  }

  getNewsForm() {
    this.newsletter = this.formBuilder.group({
      email: ['', Validators.email]
    });
  }

  subNewsletter() {
    this.success = false;
    this.error = false;
    if(this.newsletter.valid) {
      this.db.postEmail(this.newsletter.value['email']).then(data => {
        this.success = true;
      });
    } else {
      this.error = true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/footer/footer.component.ts